const EXTERNAL_AUTH_PATH_LIST = ['/affiliate']
export function isExternalAuth() {
  return EXTERNAL_AUTH_PATH_LIST.some((path) =>
    window.location.pathname.startsWith(path),
  )
}
